import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { SimpleUserWithLocation } from '@features/whereabouts/models/movements.models';

export interface OpenOfficeUser {
  user: SimpleUserWithLocation;
  amOffice?: OfficeEntity;
  pmOffice?: OfficeEntity;
}

// A floor with areas or desks lists those instead of the people booked onto the floor itself.
export function hasDesksOrAreas(office?: OfficeEntity): boolean {
  return !!office && (office.hasAreas || office.deskBookingEnabled);
}

// People in the office who don't appear in any floor, area or desk list: booked into the office itself,
// or onto a floor with areas or desks without picking one.
export function usersInOpenOffice(users: SimpleUserWithLocation[], rootOffice: OfficeEntity, floors: OfficeEntity[]): OpenOfficeUser[] {
  const openOffices = [rootOffice, ...floors.filter(hasDesksOrAreas)];
  const openOfficeFor = (officeId: number, deskId?: number) =>
    deskId ? undefined : openOffices.find((office: OfficeEntity) => office.id === officeId);

  return users
    .map((user: SimpleUserWithLocation) => ({
      user,
      amOffice: openOfficeFor(user.officeId, user.amDeskId),
      pmOffice: openOfficeFor(user.pmOfficeId, user.pmDeskId),
    }))
    .filter((openOfficeUser: OpenOfficeUser) => !!openOfficeUser.amOffice || !!openOfficeUser.pmOffice);
}
